import { axiosInstance as request } from '@api/rest.service'

const countApi = task => `/progress-bar/tasks/count/${task}/subscription-periods`
const dataApi = task => `/progress-bar/tasks/data/${task}/subscription-periods`

/**
 * @description GET /progress-bar/tasks/count/{task}/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_TASK_COUNT = (task, id) => request.get(`${countApi(task)}/${id}`)

/**
 * @description GET /progress-bar/tasks/data/{task}/subscription-periods/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_TASK_DATA = (task, id) => request.get(`${dataApi(task)}/${id}`)

/**
 * @description GET /progress-bar/tasks/data/plan-workflow/subscription-periods/{id}?paginated=true (+ ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_SUB_PERIOD_PLAN_WORKFLOW_TASK_DATA = (id, params) =>
  request.get(`${dataApi('plan-workflow')}/${id}?paginated=true`, { params })
